'use strict';
import {Injectable, Inject} from 'ng-metadata/core';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service';
import {getVid, getBackendSystem} from '../../../appConfig/appConfigForward';
import {ChangeLangService} from "../../../infra/lang/changeLang.service";

let he = require('he');

@Injectable()
export class CitationService {
    private CITATION_API_URL: string;
    private vid: string = getVid();
    private RIGHT_PADDING: number = 0.5;
    private LEFT_PADDING: number = 0.5;

    constructor(@Inject('$http') private $http: ng.IHttpService,
                private mtCacheService: MappingTablesCache,
                @Inject('restBaseURLs') restBaseURLs,
                private changeLangService: ChangeLangService) {
        this.CITATION_API_URL = restBaseURLs.pushToBaseURL + '/citation' + (getBackendSystem() === 'suprima' ? '/' + getVid() : '');
    }

    public getCitation(style, pnx, delivery, source) {
        let payload = {
            'style': style,
            'pnx': pnx,
            'delivery': delivery,
            'vid': this.vid,
            'source': source
        };
        return this.$http.post(this.CITATION_API_URL, payload);
    }

    public getAvailableStyles(): string[] {
        let table = this.mtCacheService.getTable(this.mtCacheService.tables.CITATION_STYLES);
        let sortedTable = table.sort((row1, row2) => {
            let firstSourcr1 = parseInt(row1.source1);
            let secondSource1 = parseInt(row2.source1);
            return parseInt(firstSourcr1 - secondSource1);
        }).map((row) => {
            return row.target;
        });
        return sortedTable;
    }

    public getPrimoAvailableStyles(): string[] {
        let table = this.mtCacheService.getTable(this.mtCacheService.tables.CITATION_STYLE_LANGUAGE);
        let sortedTable = table.sort((row1, row2) => {
            let firstTarget = parseInt(row1.target);
            let secondTarget = parseInt(row2.target);
            return parseInt(firstTarget - secondTarget);
        }).map((row) => {
            // adding "csl." to the label code to prevent code duplication with labels from other sources (EasyBib)
            let label = row.source1 === 'CSL' ? 'csl.' + row.source2 : row.source2;
            return label;
        });
        return sortedTable;
    }

    public decodeHtmlEntities(txt) {
        txt = txt || '';
        txt = he.decode(txt);
        return txt.replace(/&quot;/g, '').replace(/<(\/)?i>/g, '');
    }

    public decodeCitationText(txt: string) {
        return he.decode(txt);
    }

    public loadCitationStyle(data, $element) {
        let cslBibBodyElements = $element[0].querySelectorAll('.csl-bib-body');
        let cslEntryElements = $element[0].querySelectorAll('.csl-entry');
        let cslIndentElements = $element[0].querySelectorAll('.csl-indent');
        let cslRightInlineElements = $element[0].querySelectorAll('.csl-right-inline');
        let cslLeftMarginElements = $element[0].querySelectorAll('.csl-left-margin');

        for (let element of cslBibBodyElements) {
            if (data['lineSpacing']) {
                element.style.lineHeight = data['lineSpacing'];
            }
            if (cslLeftMarginElements.length === 0 && data['hangingIndent']) {
                if (this.isRTL()) {
                    element.style.marginRight = data['hangingIndent'] + 'em';
                } else {
                    element.style.marginLeft = data['hangingIndent'] + 'em';
                }
                element.style.textIndent = '-' + data['hangingIndent'] + 'em';
            }
        }

        for (let element of cslEntryElements) {
            if (data['entrySpacing']) {
                element.style.marginBottom = data['entrySpacing'] + 'em';
            }
            element.style.clear = 'left';
        }

        for (let element of cslIndentElements) {
            element.style.margin = '0.5em 0 0 2em';
            element.stylepadding = '0 0 .2em .5em';
            element.style.borderLeft = '5px solid #ccc';
        }


        for (let element of cslRightInlineElements) {
            if (this.isRTL()) {
                if (data['maxOffset']) {
                    let marginValue = data['secondFieldAlign'] ? (Number(data['maxOffset']) + this.LEFT_PADDING) : '0';
                    element.style.margin = '0 ' + marginValue + 'em' + ' 0 .4em';
                }
                if (data['hangingIndent']) {
                    element.style.paddingRight = data['hangingIndent'] + 'em';
                    element.style.textIndent = '-' + data['hangingIndent'] + 'em';
                }
            }
            else {
                if (data['maxOffset']) {
                    let marginValue = data['secondFieldAlign'] ? (Number(data['maxOffset']) + this.RIGHT_PADDING) : '0';
                    element.style.margin = '0 .4em 0 ' + marginValue + 'em';
                }
                if (data['hangingIndent']) {
                    element.style.paddingLeft = data['hangingIndent'] + 'em';
                    element.style.textIndent = '-' + data['hangingIndent'] + 'em';
                }
            }
        }

        for (let element of cslLeftMarginElements) {
            if (this.isRTL()) {
                element.style.float = 'right';
                element.style.paddingRight = this.LEFT_PADDING + 'em';
                if (data['secondFieldAlign']) {
                    element.style.textAlign = 'left';
                    if (data['maxOffset'])
                        element.style.width = data['maxOffset'] + 'em';
                }
            }
            else {
                element.style.float = 'left';
                element.style.paddingRight = this.RIGHT_PADDING + 'em';
                if (data['secondFieldAlign']) {
                    element.style.textAlign = 'right';
                    if (data['maxOffset'])
                        element.style.width = data['maxOffset'] + 'em';
                }
            }
        }
    }

    private isRTL() {
        return this.changeLangService.direction === 'rtl';
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/citation/citation.service.ts